/**
 * Les points du fil qui se chevauchent n'en font qu'un : à la largeur mesurée du fil, deux points plus proches que la
 * cible d'un doigt (24 px) se fondent. Le point fondu prend le genre le plus pressant, garde tous les
 * libellés (le survol les dit). Pur, testé.
 */
import { type UITutorRibbonEventKind, type UITutorSessionRibbon } from "../../../ports/primary/ui/types/tutorLive"

type RibbonEvent = UITutorSessionRibbon["events"][number]

export type ThreadCluster = {
    id: string
    /** Sa position, en fraction de la barre (0 à 1) : le centre de ses points. */
    x: number
    kind: UITutorRibbonEventKind
    events: RibbonEvent[]
}

/** Du plus pressant au moins pressant : la couleur d'un point fondu. */
const URGENCY: UITutorRibbonEventKind[] = [
    "hand",
    "ko",
    "error",
    "silence",
    "done",
    "ok",
    "helper",
    "quiz",
    "sent",
    "stale",
    "join",
]

/** `from` : la minute où la barre commence (défaut 0) ; elle va jusqu'à `now`. */
export function threadClusters(
    events: RibbonEvent[],
    now: number,
    width: number,
    diameter: number,
    from = 0
): ThreadCluster[] {
    const span = now - from
    if (span <= 0) return []
    const sorted = [...events].sort((a, b) => a.at - b.at)
    const groups: RibbonEvent[][] = []
    for (const event of sorted) {
        const last = groups[groups.length - 1]
        const lastAt = last?.[last.length - 1]?.at
        // Sans largeur mesurée (le premier rendu), rien ne se fond : la mesure suit.
        if (last != null && lastAt != null && width > 0 && ((event.at - lastAt) / span) * width < diameter)
            last.push(event)
        else groups.push([event])
    }
    return groups.map((group) => {
        const x = Math.min(
            1,
            Math.max(0, (group.reduce((sum, event) => sum + event.at, 0) / group.length - from) / span)
        )
        const kind = URGENCY.find((candidate) => group.some((event) => event.kind === candidate)) ?? group[0].kind
        return { id: group.map((event) => event.id).join("+"), x, kind, events: group }
    })
}
